import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import PrimaryButton from '@components/PrimaryButton';
import { ROUTES } from '@constants';
import { useStyles, useStylesBackButton } from './styles';

const BottomButtonGroup = ({
  totalPrice,
  isDisabledPayButton,
  classesPayButton,
  handleClickPayButton,
}) => {
  const classes = useStyles();
  const classesBackButton = useStylesBackButton();
  const history = useHistory();
  const { t } = useTranslation('orderScreen');

  return (
    <div className={classes.OrderBottomContainer}>
      <PrimaryButton
        text={t('back')}
        classesButton={classesBackButton}
        handleClick={() => history.push(ROUTES.MENU_SCREEN)}
      />

      <div className={classes.subContainer}>
        <Typography variant="h6" className={classes.Price}>
          € {totalPrice}
        </Typography>
      </div>

      <PrimaryButton
        text={t('pay')}
        classesButton={classesPayButton}
        handleClick={handleClickPayButton}
        isDisabledButton={isDisabledPayButton}
      />
    </div>
  );
};

export default BottomButtonGroup;
